export default __webpack_public_path__ + "static/media/onion_rings.cb391175.JPG";